<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "PaymentPage",
    components: {
        MobileTopBar,
        Breadcrumbs,
        IconPaymentVisa,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentSbp,
        IconPaymentMaestro
    },
    setup(){
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
});
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-semibold mb-5">
            Способы оплаты
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <!-- 1. Способы оплаты -->
            <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8" aria-labelledby="pm-methods">
                <h2 id="pm-methods" class="text-xl md:text-2xl font-semibold mb-4">
                    Способы оплаты
                </h2>
                <p class="mb-4">
                    Поддерживаем быстрые и понятные расчёты при заказе дорожных плит и сопутствующих изделий:
                </p>
                <ul class="list-disc list-inside space-y-2 mb-5">
                    <li><span class="font-medium">Наличные</span> — в офисе или при доставке.</li>
                    <li><span class="font-medium">Банковские карты</span> — VISA, MasterCard, МИР, Maestro.</li>
                    <li><span class="font-medium">СБП</span> — мгновенный перевод по реквизитам.</li>
                    <li><span class="font-medium">Безналичный расчёт</span> — для юрлиц (с НДС/без НДС) по счёту.</li>
                </ul>

                <div class="flex items-center gap-4" aria-label="Поддерживаемые платёжные системы">
                    <span class="sr-only">VISA</span>
                    <IconPaymentVisa class="h-10 w-auto" aria-hidden="true"/>
                    <span class="sr-only">MasterCard</span>
                    <IconPaymentMasterCard class="h-10 w-auto" aria-hidden="true"/>
                    <span class="sr-only">МИР</span>
                    <IconPaymentMir class="h-10 w-auto" aria-hidden="true"/>
                    <span class="sr-only">Maestro</span>
                    <IconPaymentMaestro class="h-10 w-auto" aria-hidden="true"/>
                    <span class="sr-only">СБП</span>
                    <IconPaymentSbp class="h-10 w-auto" aria-hidden="true"/>
                </div>
            </section>

            <!-- 2. Онлайн-оплата -->
            <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8" aria-labelledby="pm-online">
                <h2 id="pm-online" class="text-xl md:text-2xl font-semibold mb-4">
                    Онлайн-оплата
                </h2>
                <p class="mb-4">
                    После подтверждения заявки менеджер отправит защищённую ссылку для оплаты картой или переводом по
                    СБП.
                    Цена и наличие фиксируются в счёте/оферте.
                </p>
                <p class="mb-4">
                    Обработка платежей соответствует требованиям <span class="whitespace-nowrap">PCI DSS</span>.
                    Реквизиты карт не передаются и не сохраняются на серверах ООО «Дорожные-Плиты».
                </p>
                <p class="text-sm text-gray-600">
                    Чтобы ускорить процесс, укажите актуальные контактные данные (email и мессенджер) для получения
                    ссылки.
                </p>
            </section>

            <!-- 3. Безналичный расчёт для юрлиц -->
            <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8" aria-labelledby="pm-b2b">
                <h2 id="pm-b2b" class="text-xl md:text-2xl font-semibold mb-4">
                    Оплата для юридических лиц
                </h2>
                <p class="mb-4">
                    Работаем по договору поставки: подготовим счёт, счёт-фактуру и товарную накладную.
                    Возможна оплата с НДС и без НДС по согласованной спецификации.
                </p>
                <ul class="list-disc list-inside space-y-2">
                    <li>Согласуйте номенклатуру, объёмы и сроки с менеджером.</li>
                    <li>Получите счёт и оплатите удобным способом.</li>
                    <li>После поступления средств организуем сборку и отгрузку продукции.</li>
                </ul>
            </section>

            <!-- 4. Безопасность и поддержка -->
            <section class="bg-grayBg rounded-3xl px-5 md:px-8 py-8" aria-labelledby="pm-security">
                <h2 id="pm-security" class="text-xl md:text-2xl font-semibold mb-4">
                    Безопасность и поддержка
                </h2>
                <p class="mb-4">
                    Используем актуальные методы шифрования и только сертифицированные платёжные решения.
                    Все расчёты прозрачны, а персональные данные обрабатываются с соблюдением требований
                    законодательства.
                </p>
                <p class="mb-4">
                    Нужна помощь с оплатой? Ознакомьтесь с разделом
                    <Link :href="route('deliveryAndShipping')"
                          class="underline-hover-effect underline-hover-pre-effect">
                        Доставка и отгрузка
                    </Link>
                    или напишите нам через
                    <Link :href="route('contacts')" class="underline-hover-effect underline-hover-pre-effect">Контакты
                    </Link>
                    .
                    Также вы можете загрузить
                    <Link :href="route('priceList')" class="underline-hover-effect underline-hover-pre-effect">
                        Прайс-Лист
                    </Link>
                    .
                </p>

                <button
                    @click.prevent="callbackStore.showBaseCallbackPopup"
                    class="max-md:w-full mt-2 flex justify-center items-center text-center text-white hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                >
                    Задать вопрос по оплате
                </button>
            </section>
        </div>
        <p class="mt-2 text-gray-700 max-w-3xl text-sm italic">
            Выбирайте удобный способ оплаты дорожных плит и ЖБИ: наличные, банковская карта,
            перевод по СБП или безналичный расчёт для юридических лиц. Все операции проходят
            через защищённые платёжные решения.
        </p>
    </div>
</template>

<style scoped>
/* При необходимости добавьте кастомные стили */
</style>
